<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtros</h3>
      </div>

      <p class="text-base my-3">
        Selecione os campos da lista para fazer o filtro desejado:
      </p>

      <div>
          <vs-button type="border" icon="list" @click="modalFiltros = true" class="w-full lg:w-1/3">Lista de Filtros</vs-button>
      </div>

      <div class="mt-5">
        <div class="w-full" v-if="listFiltrosConfig.length > 0"><a>Configurações dos filtros:</a></div>
        <!-- Configurações -->
        <div class="flex flex-col items-center" v-for="(item, index) in listFiltrosConfig" :key="index">
          <div class="vx-row w-full mb-1 flex items-end flex-col lg:flex-row gap-3 lg:gap-0">
            <!-- Campo -->
            <div class="vx-col w-full lg:w-1/4">
              <label for="" class="vs-select--label">Campo </label>
              <vs-input v-model="item.label"  disabled class="w-full"/>
            </div>

            <!-- Operador -->
            <div class="vx-col w-full lg:w-1/6" v-if="item.tipo != 'datetime' && item.tipo !== 'betweenNumber'">
              <label for="" class="vs-select--label">Operador</label>
              <v-select
                :options="item.listOperadores"
                v-model="item.operador"
                @change="item.valor = null"
              ></v-select>
            </div>

            <!-- Valor -->
            <div class="vx-col w-full lg:w-1/3" v-if="item.operador && item.tipo !== 'datetime' && item.tipo !== 'betweenNumber'">
              <label for="" class="vs-select--label">Valor</label>
              <v-select
                v-if="item.tipo == 'lista'"

                :options="selecionaLista(item.nomeLista)"
                :name="'valor'"
                v-model="item.valor"
                label="label"
                class="fonteCampo"
                :multiple="item.operador.id == 'in' ? true : false"
              ></v-select>
              <vs-input
                v-if="item.tipo == 'text'"
                class="w-full fonteCampos"
                name="Valor"
                id="Valor"
                v-model="item.valor"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
              <!-- <flat-pickr
                v-if="item.tipo == 'datetime'"
                :config="configdateTimePicker"
                v-model="item.valor"
                placeholder="DD/MM/YYYY HH:MM"
                class="w-full fonteCampos"
                name="Valor"
              /> -->
              <money
                v-if="item.tipo == 'money'"
                class="w-full vs-inputx vs-input--input normal fonteCampos"
                name="Valor"
                id="Valor"
                v-model="item.valor"
                v-bind="money"
              ></money>
              <vs-input
                v-if="item.tipo == 'hidden'"
                class="w-full fonteCampos"
                name="Hidden"
                id="Hidden"
                value="Campo não permitido"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                disabled
              />
              <Datepicker
              v-if="item.tipo == 'mesReferencia'"
              :minimumView="'month'"
              :maximumView="'year'"
              label-placeholder="Mês Referencia Boletos"
              name="Mês Referencia Boletos"
              id="Mês Referencia"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="item.valor"
              @input="formataMesReferencia(item)"
            ></Datepicker>
            </div>

            <!-- De e Até DATA-->
            <div class="vx-col w-full flex lg:w-1/3 lg:gap-5" v-if="item.tipo == 'datetime'">
              <div>
                <label for="" class="vs-select--label">De</label>
                <flat-pickr
                v-if="item.tipo == 'datetime'"
                :config="configdateTimePicker"
                v-model="item.valor.dataInicio"
                placeholder="DD/MM/YYYY HH:MM"
                class="w-full fonteCampos"
                name="dataInicio"
                />
              </div>

              <div>
                <label for="" class="vs-select--label">Até</label>
                <flat-pickr
                v-if="item.tipo == 'datetime'"
                :config="configdateTimePicker"
                v-model="item.valor.dataFim"
                placeholder="DD/MM/YYYY HH:MM"
                class="w-full fonteCampos"
                name="dataFim"
                /> 
              </div>
            </div>

            <!-- De e Até NUMBER -->
            <div class="vx-col w-full flex lg:w-1/3 lg:gap-5" v-if="item.tipo == 'betweenNumber'">
              <div>
                <label for="" class="vs-select--label">De</label>
                <vs-input
                class="w-full fonteCampos"
                name="InicioNumber"
                id="InicioNumber"
                v-model="item.valor.inicio"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                type="number"
              />
              </div>

              <div>
                <label for="" class="vs-select--label">Até</label>
                <vs-input
                class="w-full fonteCampos"
                name="FimNumber"
                id="FimNumber"
                v-model="item.valor.fim"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                type="number"
              />
              </div>
            </div>

            <!-- Botões em Desktop de Datetime -->
            <div class=" vx-col w-full lg:w-1/4" v-if="item.tipo == 'datetime'">
              <div class="showDesktop" >
                <div class=" flex gap-2 justify-end">
                  <vs-button radius icon="save" @click="adicionaFiltro(item)" :disabled="!item.valor.dataInicio || !item.valor.dataFim"/>
                  <vs-button radius icon="delete" color="danger" @click="removeFiltroConfig(item)" />
                </div>
              </div>
  
              <!-- Botões em Mobile de Datetime -->
              <div class="showMobile">
                <div class="flex gap-2 flex-col">
                  <vs-button icon="save" @click="adicionaFiltro(item)">Adicionar filtro</vs-button>
                  <vs-button icon="delete" color="danger" @click="removeFiltroConfig(item)">Remover</vs-button>
                </div>
              </div>
            </div>
            
            <div class="vx-col w-full lg:w-1/6" v-if="item.tipo !== 'datetime'">
              <!-- Botões em Desktop outros tipos-->
              <div class="showDesktop">
                <div class=" flex gap-2 justify-end">
                  <vs-button radius icon="save" @click="adicionaFiltro(item)" :disabled="!item.valor"/>
                  <vs-button radius icon="delete" color="danger" @click="removeFiltroConfig(item)" />
                </div>
              </div>

              <!-- Botões em Mobile outros tipos -->
              <div class="showMobile" >
                <div class="flex gap-2 flex-col">
                  <vs-button icon="save" @click="adicionaFiltro(item)">Adicionar filtro</vs-button>
                  <vs-button icon="delete" color="danger" @click="removeFiltroConfig(item)">Remover</vs-button>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Lista Selecionados-->
        <div class="mt-5">
          
          <p v-if="listFiltrosSelecionados.length > 0"><a>Filtros aplicados:</a></p>
          <div
            v-for="(filtro, index) in listFiltrosSelecionados"
            :key="index"
            class="my-2 itemLista flex lg:gap-5"
          >
            <div class="vx-row w-full">
              <div class="vx-col w-1/3">
                <p>
                  <strong>Campo</strong>
                </p>
                {{ filtro.label }}
              </div>
              <div class="vx-col w-1/6">
                <p>
                  <strong>Operador</strong>
                </p>
                {{ filtro.operador.label }}
              </div>
              <div class="vx-col w-1/3">
                <p>
                  <strong>Valor</strong>
                </p>
                <span v-if="Array.isArray(filtro.valor)">{{formataRetornoArray(filtro.valor)}}</span>
                <span v-else>{{ filtro.valor.label ? filtro.valor.label : filtro.valor}}</span>
              </div>
              <div class="showDesktop vx-col w-1/6">
                <div class="flex justify-end gap-2">
                  <vs-button
                  icon="edit"
                  color="warning"
                  @click="editaFiltro(filtro)"
                  radius
                  />
                  <vs-button
                  icon="close"
                  color="danger"
                  @click="removeFiltro(filtro)"
                  radius
                  />
                </div>
              </div>
              <div class="showMobile vx-col w-1/6">
                <div class="flex flex-col gap-1">
                  <vs-button
                  size="small"
                    icon="edit"
                    color="warning"
                    @click="editaFiltro(filtro)"
                    radius
                  />
                  <vs-button
                  size="small"
                    icon="close"
                    color="danger"
                    @click="removeFiltro(filtro)"
                    radius
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Gerar Relatório -->
        <div>
          <vs-checkbox v-if="exibeFlagResumo" v-model="resumoSelecionado">Exibir Resumo</vs-checkbox>
          <vs-button
            color="success"
            class="w-full my-5"
            icon="arrow_forward"
            icon-after
            @click="$emit('gerarRelatorio')"
            >Gerar Relatório</vs-button
          >
        </div>

        <!-- Legenda-->
        <div class="my-3" >
          <p><a>Legenda:</a></p>
          <p>
            <small>
              <strong>"Igual a":</strong>
              retorna os resultados exatamente iguais ao valor selecionado.
            </small>
          </p>
          <p>
            <small>
              <strong>"Contém:</strong>
              retorna os resultados que contêm o valor selecionado em qualquer
              posição da informação. Ex: "asi" em "Brasil".
            </small>
          </p>
          <p>
            <small>
              <strong>"Em":</strong>
              retorna os resultados que estão na lista de valores selecionados.
            </small>
          </p>
        </div>
      </div>
    </vs-card>

    <!-- Modal Filtros -->
    <vs-popup :active.sync="modalFiltros" title="Lista de Filtros" @close="limpaPesquisa()">
            <!-- Lista Filtros -->
            <div class="vx-row flex flex-col-reverse lg:flex-row">
              <div class="vx-col lg:w-1/2 my-2">
                <div
                  v-for="(subArray, index) in listFiltrosLocal"
                  :key="index"
                  class="my-5 mx-2"
                >
                <div v-if="subArray.some(item => item.exibir)">
                  <h5>
                    <a>{{ subArray[0].label.charAt(0).toUpperCase() }}</a>
                  </h5>
                  <hr />
                </div>

      
                  <ul>
                    <li
                      v-for="(item, index ) in subArray"
                      :key="index"
                      class="my-2"
                      v-if="item.exibir"
                    >
                      <vs-checkbox v-model="item.checked" :vs-value="{...item}" @input="selecionaFiltro(item)">
                        {{ item.label }}
                      </vs-checkbox>
                    </li>
                  </ul>
                </div>
              </div>
      
              <!-- Pesquisar -->
              <div class="vx-col w-1/2 my-5">
                <vs-input
                  class="sticky top-0"
                  icon="search"
                  label-placeholder="Pesquisar"
                  @keyup="pesquisar"
                  v-model="termoPesquisa"
                />
              </div>
            </div>
          </vs-popup>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import moment from 'moment';
import notify from '../../../../../utils/notify'

export default {
  props: ['listFiltros', 'listas', 'filtrosFavoritos', 'exibeFlagResumo'],

  components: {
    vSelect,
    flatPickr,
    Datepicker,
  },

  watch: {
    listFiltros(){
      this.preparaFiltros()
    }, 

    listFiltrosSelecionados(value) {
      this.$emit('filtrosSelecionados', value);
    },
    resumoSelecionado(value) {
      this.$emit('exibeResumo', value);
    },

    filtrosFavoritos(arrayFiltrosFavoritos) {
      this.listFiltrosSelecionados = [];

      arrayFiltrosFavoritos.forEach(item => {
        const obj = {
          campo: item.campo,
          label: item.labelCampo,
          operador: {
            id: item.operador,
            label: this.defineLabelOperadorFavorito(item.operador),
          },
          valor: item.valor
        }

        this.listFiltrosSelecionados.push(obj)
      })
    },
  },

  data() {
    return {
      // Options
      listFiltrosLocal: [],
      listFiltrosSelecionados: [],
      listFiltrosConfig: [],

      //Configs
      modalFiltros: false,
      termoPesquisa: null,
      resumoSelecionado:false,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      configdateTimePicker: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
      },
      language: 'br',
      languages: lang,
      listasLocal: null,
    };
  },

created() {
  this.resetList()
},

  methods: {
    selecionaLista(lista){
      return this.listasLocal[lista]
    },
      resetList(name = null){
        const list = JSON.parse(JSON.stringify(this.listas));
        if(name == null){
          this.listasLocal = list;
          return
        }
        
        this.listasLocal[name] = list[name];
      },
      filterLists(item){
        if(item.valor){
          switch (item.nomeLista) {
          case 'listaRegional':
            this.listaDivisaoHandler(item);
            break;
          case 'listaDivisao':
            this.listaRegionalHandler(item);
            break; 
         }
        }
    },

    listaDivisaoHandler(item){
      let divisoes_id = []

      if(Array.isArray(item.valor)){
        item.valor.forEach(valor => {
          divisoes_id = [...divisoes_id, ... valor.divisoes.map(item => item.idDivisao)]
        });
      }else{
        if (item.valor.divisoes) {
          divisoes_id = item.valor.divisoes.map(item => item.idDivisao);
        }
      }
      
      if(divisoes_id.length > 0){

        this.resetList('listaDivisao')

        const listaDivisao = this.listasLocal.listaDivisao.filter(item => {
          if (divisoes_id.includes(parseInt(item.id)) || item.id === 'isNull') {
            return item;
          }
        });
        
        this.listasLocal.listaDivisao = listaDivisao;
      }
    },

    listaRegionalHandler(item){
      let regionais_id = []

      if(Array.isArray(item.valor)){
        item.valor.forEach(valor => {
          regionais_id = [...regionais_id, ...valor.regionais.split(',')]
        });
      }else{
        if (item.valor.regionais) {
          regionais_id = item.valor.regionais.split(',');
        }
      }
      
      if(regionais_id.length > 0){

        this.resetList('listaRegional')

        const listaRegional = this.listasLocal.listaRegional.filter(item => {
          if (regionais_id.includes(String(item.id)) || item.id === 'isNull') {
            return item;
          }
        });
        
        this.listasLocal.listaRegional = listaRegional;
      }
    },

    formataRetornoArray(array){
      let string = ''
      const arrayCopy = [...array]
      
      arrayCopy.forEach(item => {
        string = string + item.label + ', '
      })
      
      string = string.slice(0, -2)
      return string
    },

    selecionaFiltro(item){
      if(item.checked){
        this.listFiltrosConfig.push(item)
      }

      if(!item.checked){
        this.listFiltrosConfig = this.listFiltrosConfig.filter((elem) => elem.campo !== item.campo);
      } 
    },

    pesquisar() {
      const termo = this.termoPesquisa.toLowerCase().trim();
      this.listFiltrosLocal.forEach((subArray) => {
        subArray.forEach((item) => {
          const label = item.label.toLowerCase();
          item.exibir = termo === '' || label.includes(termo);
        });
      });
    }, 

    limpaPesquisa() {
      this.termoPesquisa = '';
      this.listFiltrosLocal.forEach((subArray) => {
        subArray.forEach((item) => {
          item.exibir = true;
        });
      });
    },

    defineLabelOperadorFavorito(operadorFavorito) {
      if (operadorFavorito == '=') return 'igual a';

      if (operadorFavorito == '>=') return 'maior ou igual a';

      if (operadorFavorito == '<=') return 'menor ou igual a';

      if (operadorFavorito == '>') return 'maior que';

      if (operadorFavorito == '<') return 'menor que';

      if (operadorFavorito == 'lik') return 'contém';

      if (operadorFavorito == 'in') return 'em';

      if (operadorFavorito == 'between') return 'entre';
    },

    montaOperadores(item) {
      const listOperadores = []

      if (item.operadores.includes('=')) {
        listOperadores.push({
          id: '=',
          label: 'igual a',
        });
      }

      if (item.operadores.includes('>=')) {
        listOperadores.push({
          id: '>=',
          label: 'maior ou igual a',
        });
      }

      if (item.operadores.includes('<=')) {
        listOperadores.push({
          id: '<=',
          label: 'menor ou igual a',
        });
      }

      if (item.operadores.includes('>')) {
        listOperadores.push({
          id: '>',
          label: 'maior que',
        });
      }

      if (item.operadores.includes('<')) {
        listOperadores.push({
          id: '<',
          label: 'menor que',
        });
      }

      if (item.operadores.includes('like')) {
        listOperadores.push({
          id: 'like',
          label: 'contém',
        });
      }

      if (item.operadores.includes('in')) {
        listOperadores.push({
          id: 'in',
          label: 'em',
        });
      }
      
      return listOperadores
    },

    adicionaFiltro(item) {
      if(item.tipo == 'mesReferencia'){
        const novoItemValorFormatado =  this.formataMesReferencia(item);
        item = novoItemValorFormatado
      }

      if(item.tipo == 'datetime'){
        const testeData = this.comparaDatas(item.valor.dataInicio, item.valor.dataFim)
        if(!testeData) return
        item.valor = `${item.valor.dataInicio} e ${item.valor.dataFim}`
        item.operador = {
          id: 'between',
          label: 'entre'
        }
      }

      if(item.tipo == 'betweenNumber'){
        item.valor = `${item.valor.inicio} e ${item.valor.fim}`
        item.operador = {
          id: 'between',
          label: 'entre'
        }
      }

      this.listFiltrosSelecionados.push({...item})
      item.checked = false

      this.filterLists(item);
      this.removeFiltroConfig(item)
    },

    removeFiltroConfig(item){
      item.checked = false
      if(item.tipo == "datetime"){
        item.valor = {
          dataInicio: null,
          dataFim: null
        }
      }

      if(item.tipo == "betweenNumber"){
        item.valor = {
          inicio: null,
          fim: null
        }
      }

      const indexListaConfig = this.listFiltrosConfig.indexOf(item)
      this.listFiltrosConfig.splice(indexListaConfig, 1)
    },

    removeFiltro(item) {

      // resetando lista caso necessario 
      if(item.nomeLista == 'listaRegional'){
        this.resetList('listaDivisao')
      } 
      if(item.nomeLista == 'listaDivisao'){
        this.resetList('listaRegional')
      }

      item.checked = false
      const index = this.listFiltrosSelecionados.indexOf(item);
      this.listFiltrosSelecionados.splice(index, 1);
    },

    editaFiltro(item){
      item.checked = true
      const index = this.listFiltrosSelecionados.indexOf(item)
      this.listFiltrosSelecionados.splice(index, 1)
      if(item.tipo == "datetime"){
        item.valor = {
          dataInicio: null,
          dataFim: null
        }
      }

      if(item.tipo == "betweenNumber"){
        item.valor = {
          inicio: null,
          fim: null
        }
      }
      this.listFiltrosConfig.push({...item})
    },

    limpaFiltros() {
      this.listFiltrosSelecionados = [];
    },

    preparaFiltros() {
      this.listFiltrosLocal = this.listFiltros.map((subArray) => {
        return subArray.map((item) => {
          if(item.tipo == 'datetime'){
            return { ...item, exibir: true, listOperadores: this.montaOperadores(item), valor: {dataInicio: null, dataFim: null}, operador: null};
          }
          if(item.tipo == 'betweenNumber'){
            return { ...item, exibir: true, listOperadores: this.montaOperadores(item), valor: {inicio: null, fim: null}, operador: null};
          }
          return { ...item, exibir: true, listOperadores: this.montaOperadores(item), valor: null, operador: null};
        });
      });
    },

    formataMesReferencia(item){
      const {valor, ...data} = item
      const valorFormatado = moment(valor).format('MM/YYYY')
      const indexItem = this.listFiltrosConfig.findIndex(item => (item.valor == valor && item.campo == data.campo))
      const newItem = {
        ...data, 
        valor:valorFormatado,
      }
      this.listFiltrosConfig[indexItem] = newItem;
      
      this.$emit('filtrosSelecionados', this.listFiltrosConfig);
      return newItem
    },

    comparaDatas(dataInicio, dataFim){
      // Formato daS dataS esperado: "DD/MM/YYYY"
      const inicioFormatado = dataInicio.split('/').reverse().join('-')
      const fimFormatado = dataFim.split('/').reverse().join('-')

      const inicioDate = new Date(inicioFormatado)
      const fimDate = new Date(fimFormatado)
      
      if(inicioDate > fimDate){
        notify.notifyFail(this.$vs, 'Data final maior que a data inicial.');
        return false
      } 

      return true
    } 
  },

  mounted(){
    this.preparaFiltros()
  }
};
</script>

<style>
.itemLista {
  background: #f2f2f2;
  border-radius: 10px;
  padding: 1rem;
}

.fonteCampos {
  font-size: 1em
}

.showDesktop {
  display: block;
}

.showMobile {
  display: none;
}

/* Mobile and Tablets */
@media (max-width: 959px) {
  .showDesktop {
    display: none;
  }

  .showMobile {
    display: block;
  }
}
</style>
